import userUtil from './user_util';


const generateDisplay = (submittedBy) => {
  const data = submittedBy.data;
  switch (submittedBy.type) {
    case 'USER':
      return userUtil.getFullName(data.firstName, data.lastName);
  }
};

export default generateDisplay;
